<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body {
    margin: 0;
    padding: 0;
    background-color: #ededed;
    font-size: 16px;
    height: 100%;
    overflow: hidden;
}
* {
    box-sizing: border-box;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100%;
}
.attachment-pop{
  padding: 0;
}
.mediaDialog .el-dialog__body{
  padding-top: 0;
  padding-bottom: 0;
}
textarea{
  font-family: inherit;
}
.defaultTip{
  position: absolute;
  top: 23px;
  left: 110px;
}
.defaultCommentError{
  color: red;
  margin-top: 5px;;
}
.el-dialog__body{
  overflow: hidden;
}
.customPopover, .customSelect{
  margin-top: 25px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue